
import HeaderLogo from './HeaderLogo.vue'
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  components: { HeaderLogo },
  data() {
    return {
      pageTitle: '',
    }
  },
  computed: {
    isNotHomePage() {
      return !this.$route.name.startsWith('index')
    },
  },
  mounted() {
    this.pageTitle = document.title
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
